import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

const UnknownFacet = ({ name }) => {
  return (
    <Stack spacing={2}>
      <Typography variant={'h5'}>Unknown Facet</Typography>
      <Typography variant={'body1'}>{name}</Typography>
    </Stack>
  );
};
UnknownFacet.propTypes={
  name:PropTypes.node.isRequired
};
export { UnknownFacet };
export default UnknownFacet;